export const VENTES_PUBLISHED_STATUS = "published" as const;

export type AuctionPublicationCarrier = {
  auction?: { ventesPublicationStatus?: string | null };
};

export function filterPublishedMultiplesampleAuctions<
  T extends AuctionPublicationCarrier,
>(items?: T[] | null): T[] {
  return (items ?? []).filter(
    (item) => item.auction?.ventesPublicationStatus === VENTES_PUBLISHED_STATUS,
  );
}
